// Texts of the statistics screens (channel and site), their current-value
// models and chart titles. Units shared with the rest of the console come from
// `common` (@/shared/i18n/messages); glossary: docs/design/i18n.md.

import { defineMessages } from '@/shared/i18n'

export const messages = defineMessages({
  ru: {
    navTitle: 'Статистика',
    channelTitle: 'Статистика канала',

    // Periods.
    range15m: '15 мин',
    range1h: '1 ч',
    range6h: '6 ч',
    range24h: '24 ч',
    rangeGroup: 'Период истории',

    // Charts.
    chartLoading: 'Загрузка истории…',
    historyUnavailable: 'История статистики не настроена на этой площадке.',
    historyError: 'Не удалось загрузить историю статистики.',
    dirIn: 'вход',
    dirOut: 'эфир',
    branchAudio: 'звук',
    branchDetector: 'детекторы',
    branchPull: 'источник по ссылке',
    branchPreviewAudio: 'звук превью',
    branchTranscode: 'перекод',
    seriesTrack: 'Дорожка {n}',
    seriesLeg: 'Назначение {id}',
    seriesInput: 'Вход {id}',
    seriesChannel: 'Канал {id}',

    // Channel screen.
    channelHeading: 'Статистика: {name}',
    channelCard: 'Карточка канала',
    panelVideo: 'Видео',
    panelAudio: 'Аудио',
    panelTransport: 'Транспорт',
    panelLink: 'Связь',
    panelGeneral: 'Общее',
    videoEmpty: 'Нет декодированного видео: у канала нет активного входа.',
    transportEmpty: 'Нет данных транспорта: агент ещё не прислал статус.',
    inputs: 'Входы',
    legs: 'Назначения подач',
    inputsCaption: 'Связь по входам канала',
    inputsEmpty: 'У канала нет настроенных входов.',
    legsCaption: 'Связь по назначениям подач канала',
    legsEmpty: 'У канала нет подач с назначениями.',
    generalEmpty: 'Нет данных.',
    loading: 'Загрузка…',

    chartVideoBitrate: 'Битрейт видео',
    chartVideoFps: 'FPS (факт.)',
    chartVideoGop: 'GOP',
    chartAudioBitrate: 'Битрейт звука по дорожкам',
    chartAudioIntegrated: 'Громкость, интегральная (I)',
    chartAudioTruePeak: 'True peak',
    chartPcrInterval: 'Макс. интервал PCR',
    chartTrP1: 'TR 101 290, приоритет 1',
    chartTrP2: 'TR 101 290, приоритет 2',
    chartRtt: 'RTT',
    chartLoss: 'Потери SRT: обнаружено',
    chartLost: 'Потери SRT: не восстановлено',
    chartRetrans: 'Ретрансмиссии',
    chartDrops: 'Дропы',
    chartInputBitrate: 'Битрейт входов',
    chartLegBitrate: 'Битрейт назначений',
    chartInputSwitches: 'Переключения входа за минуту',
    chartBranchSpeed: 'Скорость боковых веток',
    chartSiteAlarms: 'Алармы площадки',

    // Video rows.
    videoCodec: 'Кодек',
    videoProfile: 'Профиль @ уровень',
    videoResolution: 'Разрешение',
    videoScan: 'Развёртка',
    videoDepth: 'Разрядность / chroma',
    videoFps: 'FPS',
    videoGop: 'GOP / интервал ключевых кадров',
    videoBitrate: 'Битрейт видео',
    bits: '{n} бит',
    fpsDeclaredMeasured: '{declared} / {measured} {unit} (заявл. / факт.)',
    fpsDeclared: '{declared} {unit} (заявлен)',
    gopFrames: '{n} кадр.',

    // Audio table.
    audioEmpty: 'Нет звуковых дорожек: агент их не сообщил.',
    audioCaption: 'Звуковые дорожки канала',
    colTrack: 'Дорожка',
    colCodec: 'Кодек',
    colProfile: 'Профиль',
    colSampleRate: 'Частота',
    colChannels: 'Каналы',
    colLang: 'Язык',
    colBitrate: 'Битрейт',
    colMomentaryTitle: 'Громкость, моментальная',
    colShortTermTitle: 'Громкость, краткосрочная',
    colIntegratedTitle: 'Громкость, интегральная',
    colLraTitle: 'Диапазон громкости',
    colTruePeak: 'TP, дБТП',
    colSilence: 'Тишина',
    silence: 'тишина',
    kHz: '{n} кГц',

    // Transport rows.
    muxBitrate: 'Битрейт мультиплекса',
    nullShare: 'Доля null-пакетов',
    pcrIntervalMax: 'Макс. интервал PCR',
    trP1: 'TR 101 290, приоритет 1',
    trP2: 'TR 101 290, приоритет 2',

    // Connectivity table.
    colName: 'Название',
    colState: 'Состояние',
    colSince: 'С каких пор',
    colRtt: 'RTT',
    colLoss: 'Потери',
    colRetrans: 'Ретрансм./с',
    colDrops: 'Дропы/с',
    colBuffer: 'Буфер',
    colLatency: 'Latency',
    latencyHint: 'рекомендуем ≥ {hint} ({factor}×RTT)',
    colEncryption: 'Шифрование',
    colReconnects: 'Переподкл.',
    connected: 'подключено',
    notConnected: 'не подключено',
    perSec: '/с',
    yes: 'да',
    no: 'нет',

    // General rows.
    branchSpeedAudio: 'Звук',
    branchSpeedBlack: 'Чёрный кадр',
    branchSpeedFreeze: 'Заморозка',
    branchSpeedSilence: 'Тишина',
    activeInput: 'Активный вход',
    activeSince: 'С какого времени',
    since: 'с {time}',
    sinceAgo: 'с {time} ({duration} назад)',
    inputSwitches: 'Переключений входа',
    onSlate: 'На заставке',
    alarmsPeriod: 'Алармов за период',

    // Site screen.
    siteTitle: 'Статистика площадки',
    site: 'Площадка',
    inPeriod: 'Вход (за период)',
    outPeriod: 'Выход (за период)',
    chartSiteIn: 'Битрейт на входе площадки',
    chartSiteOut: 'Битрейт на выходе площадки',
    channelsAndRoutes: 'Каналы и подачи',
    noAgentData: 'Нет данных от агента.',
    alarms: 'Алармы',
    chartActiveAlarms: 'Активных алармов',
    alarmsActivePeriod: 'Активных (за период)',
    agent: 'Агент',
    topTitle: 'Топ проблемных каналов за сутки',
    noSites: 'Площадок нет.',
    channelsReceiving: 'Каналы в приёме',
    channelsOf: '{n} из {total}',
    routesOnAir: 'Подачи в эфире',
    maxLoss: 'Потери SRT (худшая связь)',
    agentCpu: 'CPU агента',
    agentMemory: 'Память агента',
    agentUptime: 'Аптайм агента',

    // Site screen: the GPU (only on a site that has one).
    gpu: 'GPU',
    gpuModel: 'Модель',
    gpuModelN: '{model} × {n}',
    gpuCore: 'Ядро',
    gpuEncoder: 'Кодировщик',
    gpuMemory: 'Видеопамять',
    gpuMemoryOf: 'Видеопамять из {total}',
    gpuTemperature: 'Температура',
    gpuPower: 'Мощность',
    gpuPowerOf: 'Мощность, предел {limit}',
    gpuSessions: 'Сессии NVENC',
    chartGpuUtil: 'GPU: загрузка',
    chartGpuMem: 'GPU: видеопамять',
    chartGpuTemp: 'GPU: температура',
    chartGpuPower: 'GPU: мощность',
    chartGpuSessions: 'GPU: сессии NVENC',
    chartPlayViewers: 'Зрители',
    chartAgentCpu: 'CPU агента',
    chartAgentRss: 'Память агента',
    gpuEngineCore: 'ядро',
    gpuEngineEncoder: 'кодировщик',
    gpuEngineDecoder: 'декодер',
    gpuMemUsed: 'занято',
    gpuMemTotal: 'всего',
    gpuPowerDraw: 'потребление',
    gpuPowerLimit: 'предел',

    // Top problems table.
    topEmpty: 'За этот период проблемных каналов нет.',
    topCaption: 'Топ проблемных каналов за период',
    colChannel: 'Канал',
    colMaxLoss: 'Потери SRT, обнаружено (макс.)',
    colMaxLost: 'Потери SRT, не восстановлено (макс.)',
    colMaxP1: 'TR 101 290, П1 (макс.)',
    colMaxP2: 'TR 101 290, П2 (макс.)',
  },
  en: {
    navTitle: 'Statistics',
    channelTitle: 'Channel statistics',

    range15m: '15 min',
    range1h: '1 h',
    range6h: '6 h',
    range24h: '24 h',
    rangeGroup: 'History period',

    chartLoading: 'Loading history…',
    historyUnavailable: 'Statistics history is not configured on this site.',
    historyError: 'Could not load the statistics history.',
    dirIn: 'input',
    dirOut: 'air',
    branchAudio: 'audio',
    branchDetector: 'detectors',
    branchPull: 'URL source',
    branchPreviewAudio: 'preview audio',
    branchTranscode: 'transcode',
    seriesTrack: 'Track {n}',
    seriesLeg: 'Destination {id}',
    seriesInput: 'Input {id}',
    seriesChannel: 'Channel {id}',

    channelHeading: 'Statistics: {name}',
    channelCard: 'Channel card',
    panelVideo: 'Video',
    panelAudio: 'Audio',
    panelTransport: 'Transport',
    panelLink: 'Link',
    panelGeneral: 'General',
    videoEmpty: 'No decoded video: the channel has no active input.',
    transportEmpty: 'No transport data: the agent has not reported a status yet.',
    inputs: 'Inputs',
    legs: 'Route destinations',
    inputsCaption: 'Link per channel input',
    inputsEmpty: 'The channel has no inputs configured.',
    legsCaption: 'Link per destination of the channel’s routes',
    legsEmpty: 'The channel has no routes with destinations.',
    generalEmpty: 'No data.',
    loading: 'Loading…',

    chartVideoBitrate: 'Video bitrate',
    chartVideoFps: 'FPS (measured)',
    chartVideoGop: 'GOP',
    chartAudioBitrate: 'Audio bitrate per track',
    chartAudioIntegrated: 'Loudness, integrated (I)',
    chartAudioTruePeak: 'True peak',
    chartPcrInterval: 'Max PCR interval',
    chartTrP1: 'TR 101 290, priority 1',
    chartTrP2: 'TR 101 290, priority 2',
    chartRtt: 'RTT',
    chartLoss: 'SRT loss: detected',
    chartLost: 'SRT loss: not recovered',
    chartRetrans: 'Retransmissions',
    chartDrops: 'Drops',
    chartInputBitrate: 'Input bitrate',
    chartLegBitrate: 'Destination bitrate',
    chartInputSwitches: 'Input switches per minute',
    chartBranchSpeed: 'Side branch speed',
    chartSiteAlarms: 'Site alarms',

    videoCodec: 'Codec',
    videoProfile: 'Profile @ level',
    videoResolution: 'Resolution',
    videoScan: 'Scan',
    videoDepth: 'Bit depth / chroma',
    videoFps: 'FPS',
    videoGop: 'GOP / keyframe interval',
    videoBitrate: 'Video bitrate',
    bits: '{n}-bit',
    fpsDeclaredMeasured: '{declared} / {measured} {unit} (declared / measured)',
    fpsDeclared: '{declared} {unit} (declared)',
    gopFrames: '{n} frames',

    audioEmpty: 'No audio tracks: the agent has not reported any.',
    audioCaption: 'Audio tracks of the channel',
    colTrack: 'Track',
    colCodec: 'Codec',
    colProfile: 'Profile',
    colSampleRate: 'Sample rate',
    colChannels: 'Channels',
    colLang: 'Language',
    colBitrate: 'Bitrate',
    colMomentaryTitle: 'Loudness, momentary',
    colShortTermTitle: 'Loudness, short-term',
    colIntegratedTitle: 'Loudness, integrated',
    colLraTitle: 'Loudness range',
    colTruePeak: 'TP, dBTP',
    colSilence: 'Silence',
    silence: 'silence',
    kHz: '{n} kHz',

    muxBitrate: 'Mux bitrate',
    nullShare: 'Null packet share',
    pcrIntervalMax: 'Max PCR interval',
    trP1: 'TR 101 290, priority 1',
    trP2: 'TR 101 290, priority 2',

    colName: 'Name',
    colState: 'State',
    colSince: 'Since',
    colRtt: 'RTT',
    colLoss: 'Loss',
    colRetrans: 'Retrans/s',
    colDrops: 'Drops/s',
    colBuffer: 'Buffer',
    colLatency: 'Latency',
    latencyHint: 'recommended ≥ {hint} ({factor}×RTT)',
    colEncryption: 'Encryption',
    colReconnects: 'Reconnects',
    connected: 'connected',
    notConnected: 'not connected',
    perSec: '/s',
    yes: 'yes',
    no: 'no',

    branchSpeedAudio: 'Audio',
    branchSpeedBlack: 'Black',
    branchSpeedFreeze: 'Freeze',
    branchSpeedSilence: 'Silence',
    activeInput: 'Active input',
    activeSince: 'Active since',
    since: 'since {time}',
    sinceAgo: 'since {time} ({duration} ago)',
    inputSwitches: 'Input switches',
    onSlate: 'On slate',
    alarmsPeriod: 'Alarms in period',

    siteTitle: 'Site statistics',
    site: 'Site',
    inPeriod: 'Input (over the period)',
    outPeriod: 'Output (over the period)',
    chartSiteIn: 'Site input bitrate',
    chartSiteOut: 'Site output bitrate',
    channelsAndRoutes: 'Channels and routes',
    noAgentData: 'No data from the agent.',
    alarms: 'Alarms',
    chartActiveAlarms: 'Active alarms',
    alarmsActivePeriod: 'Active (over the period)',
    agent: 'Agent',
    topTitle: 'Top problem channels, last 24 h',
    noSites: 'No sites.',
    channelsReceiving: 'Channels receiving',
    channelsOf: '{n} of {total}',
    routesOnAir: 'Routes on air',
    maxLoss: 'SRT loss (worst link)',
    agentCpu: 'Agent CPU',
    agentMemory: 'Agent memory',
    agentUptime: 'Agent uptime',

    gpu: 'GPU',
    gpuModel: 'Model',
    gpuModelN: '{model} × {n}',
    gpuCore: 'Core',
    gpuEncoder: 'Encoder',
    gpuMemory: 'Video memory',
    gpuMemoryOf: 'Video memory of {total}',
    gpuTemperature: 'Temperature',
    gpuPower: 'Power',
    gpuPowerOf: 'Power, limit {limit}',
    gpuSessions: 'NVENC sessions',
    chartGpuUtil: 'GPU: load',
    chartGpuMem: 'GPU: video memory',
    chartGpuTemp: 'GPU: temperature',
    chartGpuPower: 'GPU: power',
    chartGpuSessions: 'GPU: NVENC sessions',
    chartPlayViewers: 'Viewers',
    chartAgentCpu: 'Agent CPU',
    chartAgentRss: 'Agent memory',
    gpuEngineCore: 'core',
    gpuEngineEncoder: 'encoder',
    gpuEngineDecoder: 'decoder',
    gpuMemUsed: 'used',
    gpuMemTotal: 'total',
    gpuPowerDraw: 'draw',
    gpuPowerLimit: 'limit',

    topEmpty: 'No problem channels in this period.',
    topCaption: 'Top problem channels for the period',
    colChannel: 'Channel',
    colMaxLoss: 'SRT loss, detected (max)',
    colMaxLost: 'SRT loss, not recovered (max)',
    colMaxP1: 'TR 101 290, P1 (max)',
    colMaxP2: 'TR 101 290, P2 (max)',
  },
})

export type StatsMessageKey = keyof typeof messages.ru
